module.exports = __webpack_public_path__ + "img/PeakLogo2.91984629.png";